import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export function F({ id, label, className = "", ...props }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label htmlFor={id} className="text-xs text-slate-400">{label}</Label>
      <Input id={id} data-testid={id} className="border-white/15 bg-black/40" {...props} />
    </div>
  );
}

export function Toggle({ id, label, checked, onChange }) {
  return (
    <label className="flex items-center justify-between gap-3 rounded-lg border border-white/10 px-3 py-2.5 text-sm text-slate-200">
      {label}
      <Switch checked={!!checked} onCheckedChange={onChange} data-testid={id} />
    </label>
  );
}

export function Card({ title, children, right, testId }) {
  return (
    <div className="panel p-5 sm:p-6" data-testid={testId}>
      {(title || right) && (
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          {title && <h3 className="font-display text-2xl uppercase text-white">{title}</h3>}
          {right}
        </div>
      )}
      {children}
    </div>
  );
}

export const RedBtn = ({ children, className = "", ...p }) => (
  <button className={`btn-red rounded-full px-5 py-2.5 text-sm font-semibold disabled:opacity-50 ${className}`} {...p}>{children}</button>
);
export const GhostBtn = ({ children, className = "", ...p }) => (
  <button className={`btn-chrome rounded-full px-4 py-2 text-sm disabled:opacity-50 ${className}`} {...p}>{children}</button>
);

export const num = (v) => (v === "" || v === null || v === undefined ? null : Number(v));
